<template>
    <table id="myTable" class="table order-list table-">
        <thead>
        <tr>
            <td class="">Item Name</td>
            <td class="">Unit Rate</td>
            <td class="">Quantity</td>
            <td class="">Delivery Date</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, index) in itemrows" :key="index">
            <td class="">
                <select name="ItemId[]" v-model="row.ItemId" class="form-control" required>
                    <option v-for="(item, index) in items" :key="item.Id" :value="item.Id">{{ item.Name }}</option>
                </select>
            </td>
            <td class="">
                <input type="text" name="UnitRate[]" v-model="row.UnitRate" class="form-control" required/>
            </td>
            <td class="">
                <input type="text" name="Quantity[]"  v-model="row.Quantity" class="form-control" required/>
            </td>
            <td class="">
                <input type="date" name="DeliveryDate[]"  v-model="row.DeliveryDate" class="form-control"/>
            </td>
            <td class="">
                <a class="btn btn-sm btn-danger text-white" @click="removeRow(index)">Delete</a>
            </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
            <td colspan="5" style="text-align: left;">
                <button type="button" class="btn btn-lg btn-block btn-outline-info" v-on:click="addNewItemRow()" id="addrow">
                    Add row
                </button>
            </td>
        </tr>
        </tfoot>
<!--        <pre>{{ itemrows | json}}</pre>-->
    </table>
</template>
<script>
    export default {
        name : 'purchase-order-item-list',
        props : ['items'],
        data(){
            return {
                itemrows: [
                    {
                        Id : null,
                        ItemId: null,
                        UnitRate: null,
                        Quantity: null,
                        DeliveryDate: null
                    }
                ],
                submitted:false
            }
        },
        methods:{
            addNewItemRow: function(){
                this.itemrows.push({
                    Id : null,
                    ItemId: null,
                    UnitRate: null,
                    Quantity: null,
                    DeliveryDate: null
                });

                this.itemrows = this.checkUniqueItems(this.itemrows, 'ItemId')
            },
            removeRow: function(row){
                this.itemrows.splice(row, 1);
            },
            checkUniqueItems: function(arr, key){
                var uniqueItems = [...new Map(arr.map(item => [item[key], item])).values()]
                return uniqueItems;
            }
        },
        mounted() {
        },
    }
</script>
